import PropTypes from 'prop-types';
import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";

const CommentDelete = ({ id, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { patchData } = useData();
  const [ working, setWorking ] = useState(false);
  const [ error, setError ] = useState();

  const onConfirm = async () => {
    setWorking(true);

    // Comments can't be deleted, we edit it and remove the content and set a flag instead.
    // This will also make sure threaded comments (if ever used) won't break;
    const patchValues = {
      field_deleted: { 'value': 1 },
      comment_body: { value: '-- verwijderd --' },
    }
    const result = await patchData(id, 'comment', patchValues);
    if (result?.status === 200) {
      hideDialog();
      if (onCompleted) {
        onCompleted();
      }
    } else {
      setError(`De reactie is niet verwijderd (${ result?.status })`);
    }
    setWorking(false);
  };

  return (
    <Dialog title={ `Reactie verwijderen` }
            loading={ working }
            errorMessage={ error }>
      <>
        <div className={ `dialog__row` }>
          <h3>Weet u zeker dat u de reactie wilt verwijderen?</h3>
        </div>
        <div className="dialog__buttons">
          <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
          <Button variant={ `secondary` } onClick={ onConfirm }>Verwijderen</Button>
        </div>
      </>
    </Dialog>
  )
}

CommentDelete.propTypes = {
  id: PropTypes.number.isRequired,
  onDeleted: PropTypes.func,
}

export default CommentDelete;
